import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryProcessDetailByBomListId } from '@/api/queryTemplate';
export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      tableData: []
    };
  },
  methods: {
    getProcessPlateList: function () {
      var _getProcessPlateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return queryProcessDetailByBomListId(id);
            case 2:
              result = _context.sent;
              if (result.code === 200) {
                this.tableData = result.data.list;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProcessPlateList(_x) {
        return _getProcessPlateList.apply(this, arguments);
      }
      return getProcessPlateList;
    }()
  }
};